import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const TOKEN_KEY = "crm_token";
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
api.interceptors.response.use((r) => r, (e) => {
  if (e.response?.status === 401 && !e.config?.url?.includes("/auth/")) {
    localStorage.removeItem(TOKEN_KEY);
    if (!["/login", "/privacidade"].includes(window.location.pathname)) window.location.assign("/login");
  }
  return Promise.reject(e);
});

export const apiError = (e, fallback = "Algo deu errado. Tente novamente.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ") || fallback;
  return fallback;
};

export const fmtBRL = (v) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(v || 0);

export const fmtDate = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso + (iso.length === 10 ? "T00:00:00" : ""));
  if (isNaN(d)) return iso;
  return d.toLocaleDateString("pt-BR");
};

export const STATUS = {
  ativo: { label: "Ativo", text: "#34D399", bg: "rgba(16,185,129,0.12)", border: "rgba(16,185,129,0.3)" },
  vencido: { label: "Vencido", text: "#F87171", bg: "rgba(239,68,68,0.12)", border: "rgba(239,68,68,0.3)" },
  a_vencer: { label: "A Vencer", text: "#FBBF24", bg: "rgba(245,158,11,0.12)", border: "rgba(245,158,11,0.3)" },
  teste: { label: "Teste", text: "#C084FC", bg: "rgba(168,85,247,0.12)", border: "rgba(168,85,247,0.3)" },
  sem_vencimento: { label: "Sem venc.", text: "#94A3B8", bg: "rgba(148,163,184,0.12)", border: "rgba(148,163,184,0.3)" },
  desativado: { label: "Desativado", text: "#64748B", bg: "rgba(100,116,139,0.12)", border: "rgba(100,116,139,0.3)" },
  pago: { label: "Pago", text: "#38BDF8", bg: "rgba(14,165,233,0.12)", border: "rgba(14,165,233,0.3)" },
};
